import { authKey } from 'app/auth/AuthSlice';

const requestImage = function (url: string, element: HTMLIFrameElement) {
  const request = new XMLHttpRequest();
  request.responseType = 'blob';
  request.open('get', url, true);
  const auth = localStorage.getItem(authKey);
  if (auth) {
    request.setRequestHeader(
      'Authorization',
      'Bearer ' + JSON.parse(auth).access_token
    );
  }

  request.onreadystatechange = () => {
    if (request.readyState == XMLHttpRequest.DONE && request.status == 200) {
      element.src = URL.createObjectURL(request.response);
      element.onload = () => {
        URL.revokeObjectURL(element.src);
      };
    }
  };
  request.send(null);
};

class AuthEmbed extends HTMLIFrameElement {
  _lastUrl: string | null = null;
  constructor() {
    super();
    this._lastUrl = '';
  }

  static get observedAttributes() {
    return ['authsrc'];
  }

  connectedCallback() {
    const url = this.getAttribute('authsrc');
    if (url !== this._lastUrl) {
      this._lastUrl = url;
      if (url) {
        requestImage(url, this);
      }
    }
    console.log('connectedCallback() is called.');
  }
}

export default function configure() {
  window.customElements.define('auth-embed', AuthEmbed, { extends: 'iframe' });
}
